<template>
    <h-tab-group as="div"
        v-bind="groupProperties"
        @change="onChange">
        <slot></slot>
    </h-tab-group>
</template>

<script setup lang="ts">
const properties = defineProps<{
    syncWithUrl?: boolean
}>();

const emit = defineEmits<{
    (event: 'change', index: number): void
}>();

const route = useRoute();
const router = useRouter();

const selectedIndex = ref(route.hash ? Number(route.hash.replace(/^#t/, '')) : 0);

// Don't pass `selectedIndex` if url syncing isn't requested, to keep the component uncontrolled.
const groupProperties = computed(() => (properties.syncWithUrl ? ({
    selectedIndex: selectedIndex.value,
}) : {}));

function onChange(index: number) {
    emit('change', index);
    selectedIndex.value = index;
    if (selectedIndex.value === 0) {
        router.replace(route.fullPath.replace(/#t\d+$/, ''));
        return;
    }
    router.replace(`${route.fullPath.replace(/#.*$/, '')}#t${index}`);
}
</script>
